import Icon from './Icon';
import BirthdayIcon from './BirthdayIcon';
import PaymentIcon from './PaymentIcon';
import DownloadIcon from './DownloadIcon';

export default Icon;
export { BirthdayIcon, PaymentIcon, DownloadIcon };
